import { api, getAiApiUrl } from '@/lib/utils/api.utils'

export interface Story {
  summary: string
  symbol: string
  [property: string]: any
}

export interface TraderProfile {
  /**
   * 见解
   */
  insights: string[]
  /**
   * 标签
   */
  labels: string[]
  /**
   * 昵称
   */
  nickname: string
  /**
   * 故事详情
   */
  story: Story[]
  /**
   * 建议
   */
  suggestion: string
  /**
   * 简介
   */
  trader: string
  [property: string]: any
}

export interface UserDetail {
  address: string
  symbol: string
  assets: number
  pnl: number
  pnlPercent: number
  winRate: number
  profitTrades: number
  lossTrades: number
  maxProfit: number
  maxLoss: number
  maxDrawdown: number
  avgHold: number
  maxHold: number
  isFollowed?: boolean
}

/**
 * Fetches trader profile information by address
 * @param address - The trader's wallet address
 * @returns Promise with trader profile data
 */
export async function getTraderProfile(address: string): Promise<TraderProfile> {
  try {
    const response = await api.get(`${getAiApiUrl()}/profile/${address}`, {
      timeout: 20000,
    })
    
    const result: { message: string } = await response.json()

    // Parse the JSON from the message field to get the actual trader profile data
    const profileData: TraderProfile = JSON.parse(result.message)
    return profileData
  }
  catch (error) {
    console.error('Failed to fetch trader profile:', error)
    throw error
  }
}

/**
 * Fetches user detail information by address and symbol
 * @param address - The user's wallet address
 * @param symbol - The trading symbol
 * @returns Promise with user detail data
 */
export async function getUserDetail(address: string, userAddress?: string): Promise<UserDetail> {
  try {
    const response = await api.get(`${getAiApiUrl()}/user/detail/${address}`, {
      searchParams: userAddress ? { userId: userAddress } : undefined,
    })
    return await response.json()
  }
  catch (error) {
    console.error('Failed to fetch user detail:', error)
    throw error
  }
}
